import { useState } from 'react';

export type EvaluationFilterType = 'All' | 'Current';

export const useEvaluationFilters = () => {
  const [evaluationFilter, setEvaluationFilter] =
    useState<EvaluationFilterType>('All');

  const updateEvaluationFilter = (filter: EvaluationFilterType) => {
    setEvaluationFilter(filter);
  };

  return {
    evaluationFilter,
    updateEvaluationFilter,
  };
};
